import moment from 'moment'
import { Link } from 'react-router-dom'

import { type IChosenInsuredProgram, type IInsuredContract } from '@/app/types/dmsTypes'
import { routes } from '@Config/config'

import { CurrentProgram } from './CurrentProgram/CurrentProgram'
import style from './ProgramContracts.module.scss'

interface IProps {
    contracts: IInsuredContract[]
    companyId: string
}

export const ProgramContracts = (props: IProps) => {
    const { contracts, companyId } = props
    return (
        <div className={style.container}>
            {contracts
                .slice()
                .sort((a, b) => (a.conclusionAt < b.conclusionAt ? 1 : -1))
                .map((contract) => {
                    const { contractId, contractName, programs, conclusionAt, finishedAt } = contract

                    const PROGRAMS_MAPPER: Record<number, IChosenInsuredProgram[]> = {
                        0: programs,
                        1: programs
                    }

                    const attachedPrograms = PROGRAMS_MAPPER[0]

                    return (
                        <div key={contractId} className={style.contractWrapper}>
                            <div className={style.contractNameWrapper}>
                                <Link
                                    className={style.contractName}
                                    to={`${routes.DMSM}/companies/${companyId}/contracts`}
                                >
                                    {contractName}
                                </Link>
                                <span className={style.programsInfo}>
                                    {programs.length > 0
                                        ? `(${programs.length} прог.)`
                                        : '(Договор не содержит программ)'}
                                </span>
                                <span className={style.programsRange}>
                                    {moment(conclusionAt).utc().format('DD.MM.YYYY')} -{' '}
                                    {moment(finishedAt).utc().format('DD.MM.YYYY')}
                                </span>
                            </div>
                            <div className={style.programs}>
                                {attachedPrograms.map((program) => (
                                    <CurrentProgram key={program.id} contractId={contractId} {...program} />
                                ))}
                            </div>
                        </div>
                    )
                })}
        </div>
    )
}
